<template>
  <div style="padding: 25px; max-width: 500px; margin: auto">
    <el-card :body-style="{padding: '50px'}">
      <h1>用户信息填报</h1>
      <el-form ref="user-form" size="small" :model="m">
        <el-form-item label="用户名"
                      prop="name"
                      :rules="[{required: true, message: '用户名不能为空'}, {min: 2, message: '用户名不能少于2个字'}]">
          <el-input v-model="m.name"></el-input>
        </el-form-item>
        <el-form-item label="电话"
                      prop="mobile"
                      :rules="[{required: true, message: '用户电话不能为空'},{min: 11, max: 11, message: '电话位数不正确'}]">
          <el-input v-model="m.mobile"></el-input>
        </el-form-item>
        <el-form-item class="text-center">
          <el-button @click="submit" type="primary">提交</el-button>
          <el-button @click="cancel">放弃</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import User from "@/models/User";
import UserService from "@/services/user/UserService";

export default {
  name: "UserForm",
  props: {
    model: new User()
  },
  data() {
    return {
      m: new User()
    }
  },
  watch: {
    model(n) {
      this.m = new User(n)
    }
  },
  methods: {
    submit() {
      this.$refs['user-form'].validate(valid => {
        if (valid) {
          this.loading = true
          UserService
              .save(new User(this.m))
              .then(resp => {
                if (resp.status === 200) {
                  this.$message.success("已成功保存" + this.m.name + " 用户信息")
                  this.$emit('close')
                }
              })
              .finally(() => {
                this.loading = false
              })
        }
      })
    },
    cancel() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
